import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FileUploadComponent } from 'src/app/components/file-upload/file-upload.component';
import { DAPDeficiency } from 'src/app/models/dap-deficiency.model';
import { DeficiencyModel } from 'src/app/models/deficiency.model';
import { ProgramReviewAssesments } from 'src/app/models/program-review-assessments-model';
import { TrainingProgramAttestationSection } from 'src/app/models/tp-attestation-section.model';
import { TrainingProgramReqQuestion } from 'src/app/models/training-program-req-question.model';
import { TrainingProgramApplicationUtils } from 'src/app/utils/training-program-application.util';

@Injectable({
  providedIn: 'root'
})
export class DeficienciesCalculatorService {
  resetSidebar = new Subject<boolean>();
  resetQuestionsInEditMode = new Subject<TrainingProgramReqQuestion | null>();

  selectedPageName: string = 'ApplicantInformation';
  selectedTabTitle: string = '';
  pageNameToLoadContentFor: string = "TPRegistrationConfirmationSidebar";
  questionInEditMode: TrainingProgramReqQuestion | null = null;

  tpAppUtils = TrainingProgramApplicationUtils;

  deficiencies = {}
  defData: ProgramReviewAssesments[]
  fileUploads: FileUploadComponent[] = []
  hasAllDeficiencyResponsed: boolean = false
  // CMS Standard 2.0 - flag to indicate that some unanswered Questions exist
  hasAnyUnansweredQuestions: boolean = false
  // CMS Standard 2.0 - store Program Attestation Section object (with Answers) to save it later
  unsavedAnswers: TrainingProgramAttestationSection[] = [];

  deficiencyTitles = [this.tpAppUtils.ApplicantInformation,
  this.tpAppUtils.TrainingProviderAttestation,
  this.tpAppUtils.TrainingProgramAttestation,
  this.tpAppUtils.AttestationCertification,
  this.tpAppUtils.ProofOfMaterialPurchase,
  this.tpAppUtils.LessonPlan,
  this.tpAppUtils.InstructorManual,
  this.tpAppUtils.PresentationMaterial,
  this.tpAppUtils.ParticipantManual,
  this.tpAppUtils.AssociateHandouts,
  this.tpAppUtils.QuickReferenceMaterial,
  this.tpAppUtils.EquipmentList,
  this.tpAppUtils.LearnerEvaluationPlan,
  this.tpAppUtils.WrittenTestsAndAssements,
  this.tpAppUtils.QualityAssuranceAndContinuousImprovementsPlan,
  this.tpAppUtils.DetailedDesignDocument,
  this.tpAppUtils.StoryBoard,
  this.tpAppUtils.ELearningCourse,
  this.tpAppUtils.ProofOfTrainingCompletionDocument,
  this.tpAppUtils.ProgramStandards,
  this.tpAppUtils.ProgramDocumentsDesk,
  this.tpAppUtils.ProviderStandards
  ]

  constructor(
  ) { }

  getDeficiencyCountByPageName(pageName): number {
    let count = 0
    this.deficiencyTitles.forEach(x => {
      if (this.deficiencies[x] &&this.deficiencies[x].deficiencyNotes.filter(z => z.DeficiencyContentHTML).length > 0 && (pageName == null || this.tpAppUtils.getPageNameBySectionName(this.deficiencies[x].pageName) == pageName || pageName == this.deficiencies[x].pageName)) {
        let unresponded = this.deficiencies[x].deficiencyNotes.filter(x => x.DeficiencyRespondedDate == null)
        count += unresponded.length
      }
    })
    return count
  }

  initDeficiencyCounts(defData: ProgramReviewAssesments[], defNotes: DeficiencyModel[], canEdit: boolean = true) {
    this.defData = defData
    let previousDapRespondedDate = sessionStorage.getItem('previousDapRespondedDate');

    if (defData.filter(x => x.PageName == this.tpAppUtils.ProgramStandards && x.SectionName.indexOf('|') > 0).length > 0) {
      defData.filter(x => x.PageName == this.tpAppUtils.ProgramStandards && x.SectionName.indexOf('|') > 0).forEach(y => {
        let notes = defNotes.filter(z => z.DeficiencyGroup == y.SectionName)
        notes.forEach(note => note.PageName = y.PageName)
      });
    }
    if (defData.filter(x => x.PageName == this.tpAppUtils.ProviderStandards && x.SectionName.indexOf('|') > 0).length > 0) {
      defData.filter(x => x.PageName == this.tpAppUtils.ProviderStandards && x.SectionName.indexOf('|') > 0).forEach(y => {
        let notes = defNotes.filter(z => z.DeficiencyGroup == y.SectionName)
        notes.forEach(note => note.PageName = y.PageName)
      });
    }

    defNotes.forEach(x => x.ReadOnly = !canEdit || (previousDapRespondedDate != null && previousDapRespondedDate != "" && x.CreatedDate != null && new Date(x.CreatedDate) <= new Date(previousDapRespondedDate)))
    this.deficiencyTitles.forEach(x => {
      this.deficiencies[x] = new DAPDeficiency(x, defData.filter(y => y.SectionName == x && y.Option == 1).length)

      let data = defNotes.filter(y => y.DeficiencyGroup == x || y.PageName == x)
      this.deficiencies[x].deficiencyNotes = data
      this.deficiencies[x].deficiencyCount = data.length
    });
    
    this.checkDeficiencyResponded();
  }

  getDeficiencyCountBySectionName(sectionName: string, subSectionName?: string): number {
    if (!this.deficiencies[sectionName]) return 0
    let unresponded = subSectionName == null ? this.deficiencies[sectionName].deficiencyNotes.filter(x => x.DeficiencyRespondedDate == null) : this.deficiencies[sectionName].deficiencyNotes.filter(x => x.DeficiencyGroup == subSectionName && x.DeficiencyRespondedDate == null)
    return unresponded.length;
  }

  checkDeficiencyResponded() {
    this.hasAllDeficiencyResponsed = true;
    this.deficiencyTitles.forEach(x => { if (this.deficiencies[x].deficiencyNotes.filter(x => !x.DeficiencyResponse).length > 0) this.hasAllDeficiencyResponsed = false; }); 
  }
}
